import React from 'react';
import { connect } from 'react-redux';

const SponsorshipListSummaryItemComponent = ({ name, value }) => {
    return (
        <div>
            <div className="item-value">{value}</div>
            <div className="item-name">{name}</div>
        </div>
    );
};

const mapStateToProps = () => {
    return {};
};

const SponsorshipListSummaryItem = connect(mapStateToProps)(SponsorshipListSummaryItemComponent);
export default SponsorshipListSummaryItem;